/** ZeroTail chart palette aligned with tailwind zt-* tokens */
export const CHART_COLORS = [
  '#10B981', // primary
  '#34D399', // accent
  '#3B82F6', // info
  '#F59E0B', // warning
  '#EF4444', // danger
  '#8B5CF6',
  '#06B6D4',
  '#F472B6',
] as const;

export const CHART_THEME = {
  grid: '#1F2937',
  axis: '#94A3B8',
  tooltipBg: '#111827',
  tooltipBorder: '#1F2937',
  revenue: '#10B981',
  expenses: '#EF4444',
  cashFlow: '#3B82F6',
  connected: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
} as const;

export const chartTooltipStyle = {
  backgroundColor: CHART_THEME.tooltipBg,
  border: `1px solid ${CHART_THEME.tooltipBorder}`,
  borderRadius: '8px',
  color: '#E2E8F0',
  fontSize: '12px',
};

export function formatChartCurrency(value: number): string {
  if (Math.abs(value) >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 1_000) return `$${(value / 1_000).toFixed(1)}k`;
  return `$${value.toFixed(0)}`;
}
